<template>
	<div class="gruop-wrapper">
		<Table-Dialog :showTable1.sync="showTable1" @createGroup='createGroup' />
		<Table-Dialog :showTable.sync="showTable" :groupIdTpp.sync="groupIdTpp" @bindShop='bindShop' />
		<!-- <Table-Dialog :showTable1.sync="showTable1" @createGroup='createGroup' /> -->
		<Table-Dialog :showTable3.sync="showTable3"  :FeeOptions.sync='FeeOptions' :otherCost.sync="otherCost" @freshData="freshData" @deleteData="deleteData"  @updateData="updateData"/>
		<!-- <loading style="margin-top: 250px;"  v-if="!groupInfo.length"></loading> -->
		<div>
			<div  style="margin-bottom: 15px;">
				<span>{{$t('other.a1669')}}：</span>
				<el-select style="width: 120px;margin-left: 15px"  v-model="value" :placeholder="$t('other.a50')">
				    <el-option
				      v-for="item in options"
				      :key="item.value"
				      :label="item.label"
				      :value="item.value">
				    </el-option>
				 </el-select>
				 <el-date-picker
				     v-show="value === '3'"
					 style="margin-left: 15px"
				     v-model="monthValue"
				     type="month"
				     :placeholder="$t('other.a1670')">
				 </el-date-picker>
				 <el-date-picker
				    style="width: 120px;margin-left: 15px"
				    v-show="value === '1' || value == '2'"
				    v-model="yearValue"
				    align="right"
				    type="year"
				    :placeholder="$t('other.a1671')">
				  </el-date-picker>
				  <el-select v-show="value == '2'" style="width: 120px;margin-left: 15px;"  v-model="quartersValue" :placeholder="$t('other.a1672')">
				      <el-option
				        v-for="item in quaterOptions"
				        :key="item.value"
				        :label="item.label"
				        :value="item.value">
				      </el-option>
				  </el-select>
				  <el-button size="medium" style="margin-left: 15px;" type="primary" @click="getGropInfo"><i class="iconfont  icon-shuaxin2 "></i>{{$t('other.a1673')}}</el-button>
			</div>
			<el-button type="primary" @click="showTable1=true">{{$t('other.a1649')}}</el-button>
			<div>
				<el-table
				    :data="groupInfoCopy"
				    style="width:73%"
					height="560"
					:key="itemKey"
				    :default-sort = "{prop: 'date', order: 'descending'}"
				    >
					<el-table-column type="expand">
						
					  <template slot-scope="scope">
						  <!-- <span>{{scope.row.shopId}}</span> -->
						  <el-table
						      :data="scope.row.shopGroups"
						      border
						      >
						      <el-table-column
						        prop="shopName"
						        :label="$t('other.a1674')"
						        width="120">
								 <template scope="scope">
						  	 	<span>{{showshopNameByshopIdOne(scope.row.groupSalas.shopId)}}({{countryName[checkkShopname(scope.row.groupSalas.shopId)]}})</span>
						  	 </template>
						      </el-table-column>

							    <el-table-column
						       prop="sales.serviceFee"
						       :label="$t('other.a1675')"
							   width="120"
						       >
							   <template scope="scope">
						  	 	<span>￥{{scope.row.groupSalas.saleroom==null ? '-' : scope.row.groupSalas.saleroom.toFixed(2)}}</span>
						  	 </template>
						     </el-table-column>
							 <el-table-column
						       prop="sales.serviceFee"
						       :label="$t('other.a1676')"
							   width="120"
						       >
							   <template scope="scope">
						  	 	<span>{{scope.row.groupSalas.comparative==null ? '-' : ((scope.row.groupSalas.comparative)*100).toFixed(2)}}%</span>
						  	 </template>
						     </el-table-column>
							 <!-- <el-table-column
						       prop="sales.serviceFee"
						       :label="$t('other.a1687')"
							   width="120"
						       >
							   <template scope="scope">
						  	 	<span>{{scope.row.otherCost.cost}}</span>
						  	 </template>
						     </el-table-column> -->
							   <!-- <template scope="scope">
						  	 	<span>{{scope.row.groupSalas ? scope.row.groupSalas.saleroom.toFixed(2) : '-'}}</span>
						  	 </template>
						     </el-table-column> -->
						  	 


							      <!-- <el-table-column
						       width="120"
						       label="毛收入总额"
						       >
						  	 <template scope="scope">
						  	 	<span>{{scope.row.groupSalas ? scope.row.groupSalas.escrowAmount.toFixed(2) : '-'}}</span>
						  	 </template>
						     </el-table-column> -->


							  <!-- <el-table-column
						       prop="sales.returnMoney"
						       :label="$t('other.a301')"
							   width="120"
						       >
						  	 <template scope="scope">
						  	 	<span>{{scope.row.groupSalas ? (scope.row.groupSalas.grossRate*100).toFixed(2) : '-'}}</span>
						  	 </template>
						     </el-table-column> -->

							 <!-- <el-table-column
						       prop="sales.returnMoney"
						       :label="$t('other.a180')"
							   width="120"
						       >
						  	 <template scope="scope">
						  	 	<span>{{scope.row.groupSalas ? scope.row.groupSalas.turnover.toFixed(2)*100 : '-'}}</span>
						  	 </template>
						     </el-table-column> -->

							 <!-- <el-table-column
						       prop="sales.returnMoney"
						       label="金额周转率"
							   width="120"
						       >
						  	 <template scope="scope">
						  	 	<span>{{scope.row.groupSalas ? (scope.row.groupSalas.capitalTurnover*100).toFixed(2) : '-'}}</span>
						  	 </template>
						     </el-table-column> -->

						     <el-table-column
						       prop="sales.saleroom"
						       :label="$t('other.a1677')"
							   width="120"
							   
						       >
						  	 <template scope="scope">
						  	 	<span>￥{{mathnum(scope.row.groupSalas.advCost==null ? '0' : scope.row.groupSalas.advCost.toFixed(2))}}</span>
						  	 </template>
						     </el-table-column>

							   <!-- <el-table-column
						       prop="total "
						       label="断货次数"
						       >
						  	 <template scope="scope">
						  	 	<span>{{scope.row.groupSalas.supplyShortageNum==null ? '-' : scope.row.groupSalas.supplyShortageNum.toFixed(0)}}</span>
						  	 </template>
						     </el-table-column>

							 <el-table-column
						       prop="total "
						       label="断货天数"
						       >
						  	 <template scope="scope">
						  	 	<span>{{scope.row.groupSalas.supplyShortageDay==null ? '-' : scope.row.groupSalas.supplyShortageDay.toFixed(0)}}</span>
						  	 </template>
						     </el-table-column> -->
							 

							     <el-table-column
						       prop="sales.productCost"
						       :label="$t('other.a1678')"
							   width="120"
						       >
						  	 <template scope="scope">
						  	 	<span>￥{{scope.row.groupSalas.itemCost==null ? '0' : scope.row.groupSalas.itemCost.toFixed(2)}}</span>
						  	 </template>
						     </el-table-column>
						     <el-table-column
						       prop="sales.adsCharge"
						       :label="$t('other.a1679')"
							   width="120"
						       >
						  	 <template scope="scope">
						  	 	<span>￥{{scope.row.groupSalas.claim==null ? '0' : scope.row.groupSalas.claim.toFixed(2) }}</span>
						  	 </template>
						     </el-table-column>
						 	 <el-table-column
						       prop="sales.adsCharge"
						       :label="$t('other.a1680')"
							   width="120"
						       >
						  	 <template scope="scope">
						  	 	<span>￥{{scope.row.groupSalas.returnPrice==null ? '0' : scope.row.groupSalas.returnPrice.toFixed(2) }}</span>
						  	 </template>
						     </el-table-column>
						     
						 
						   
						     <!-- <el-table-column
						       prop="total "
						       :label="$t('other.a1684')"
							   width="140"
						       >
						  	 <template scope="scope">
								   
						  	 	<span>￥{{(scope.row.groupSalas.saleroom - scope.row.groupSalas.itemCost -  (scope.row.groupSalas.shipCost==null? 0 : scope.row.groupSalas.shipCost) + (scope.row.groupSalas.advCost==null? 0 : scope.row.groupSalas.advCost)  +  (scope.row.groupSalas.claim==null? 0 :scope.row.groupSalas.claim)).toFixed(2)}}</span>
						  	 </template>
						     </el-table-column>

							 <el-table-column
						       prop="total "
						       :label="$t('other.a1685')"
							   width="140"
						       >
						  	 <template scope="scope">
						  	 	<span>{{((scope.row.groupSalas.saleroom - scope.row.groupSalas.itemCost -  (scope.row.groupSalas.shipCost==null? 0 : scope.row.groupSalas.shipCost) + (scope.row.groupSalas.advCost==null? 0 : scope.row.groupSalas.advCost)  +  (scope.row.groupSalas.claim==null? 0 :scope.row.groupSalas.claim))/scope.row.groupSalas.saleroom).toFixed(2)*100}}%</span>
						  	 </template>
						     </el-table-column>
							
							 <!-- <el-table-column
						       prop="total "
						       label="得分"
						       >
						  	 <template scope="scope">
						  	 	<span>{{scope.row.groupSalas.score==null ? '0' : scope.row.groupSalas.score.toFixed(2)}}</span>
						  	 </template>
						     </el-table-column> -->
							 <el-table-column
						       prop="total "
						       :label="$t('other.a1681')"
						       >
						  	 <template scope="scope">
						  	 	<span>￥{{scope.row.groupSalas.shipCost==null ? '0' : scope.row.groupSalas.shipCost.toFixed(2)}}</span>
						  	 </template>
						     </el-table-column>
							 
							
						     <!-- <el-table-column
							   fixed="right"
						       prop="shop.shopName"
						       :label="$t('other.a33')"
						  	 width="210"
						       >
						  	 <template scope="scope">
						  	 	<el-button size="mini" type="primary" @click="addFeeOptions(scope.row,0)">查看自定义细项</el-button>
						  		<el-button size="mini" type="primary" @click="deleShopGroup(scope.row)">{{$t('other.a2925')}}</el-button>
						  	 </template>
						     </el-table-column> -->
						     
						    </el-table>
					  </template>
					</el-table-column>
				    <el-table-column
				      prop="name"
				      :label="$t('other.a1650')"
					  width="150"
				      >
					  <template scope="scope">
					  	<span v-show="!scope.row.checked">{{scope.row.name}}</span>
						
						<el-input v-show="scope.row.checked"  style="width: 100px;" size="mini" v-model="scope.row.name"></el-input>
						<i v-show="!scope.row.checked" @click="nnfnv(scope.row,0)" class="el-icon-edit " ></i>
						<el-button v-show="scope.row.checked" @click="nnfnv(scope.row,1)" size="mini" type="danger">{{$t('other.a145')}}</el-button>
					  </template>
				    </el-table-column>
					<!-- <el-table-column
				      prop="groupId"
				      label="小组ID"
					  width="150"
				      >
				    </el-table-column>
					<el-table-column
				      prop="createTime"
				      :label="$t('other.a57')"
					  width="150"
				      >
					  <template scope="scope">
					  	<span>{{getTiem(scope.row.createTime)}}</span>
					  </template>
				    </el-table-column> -->
					
						<el-table-column
				      prop="saleroom"
				      :label="$t('other.a1675')"
					  width="120"
				      sortable
				      >
					  <template scope="scope">
					  	<span>￥{{scope.row.Tol_PerforMancd.saleroom.toFixed(2)}}</span>
					  </template>
				    </el-table-column>
					<el-table-column
				      prop="saleroom"
				      :label="$t('other.a1676')"
					  width="120"
				      sortable
				      >
					  <template scope="scope">
					  	<span v-if="scope.row.shopGroups!=null">{{ ((scope.row.Tol_PerforMancd.saleroomRatio/scope.row.Tol_PerforMancd.saleroom)*100).toFixed(2)}}%</span>
						    <span v-if="scope.row.shopGroups==null">{{$t('other.a1682')}}</span>
					  </template>
				    </el-table-column>
					<!-- <el-table-column
				      prop="saleroom"
				      label="商品总数"
					  width="120"
				      sortable
				      >
					  <template scope="scope">
					  	<span>{{scope.row.Tol_PerforMancd.itemAmount}}</span>
					  </template>
				    </el-table-column>
					<el-table-column
				      prop="saleroom"
				      label="生成订单总数"
					  width="120"
				      sortable
				      >
					  <template scope="scope">
					  	<span>{{scope.row.Tol_PerforMancd.orderAmount}}</span>
					  </template>
				    </el-table-column> -->

					<!-- <el-table-column
				      prop="saleroom"
				      :label="$t('other.a301')"
					  width="120"
				      sortable
				      >
					  <template scope="scope">
					  	<span>{{(scope.row.Tol_PerforMancd.grossRate*100).toFixed(2) }}</span>
					  </template>
				    </el-table-column>
					<el-table-column
				      prop="saleroom"
				      label="毛收入总额"
					  width="120"
				      sortable
				      >
					  <template scope="scope">
					  	<span>{{scope.row.Tol_PerforMancd.escrowAmount}}</span>
					  </template>
				    </el-table-column> -->
					<!-- <el-table-column
				      prop="saleroom"
				      :label="$t('other.a180')"
					  width="120"
				      sortable
				      >
					  <template scope="scope">
					  	<span>{{scope.row.Tol_PerforMancd.turnover}}</span>
					  </template>
				    </el-table-column> -->
					<!-- <el-table-column
				      prop="saleroom"
				      label="金额周转率"
					  width="120"
				      sortable
				      >
					  <template scope="scope">
					  	<span>{{scope.row.Tol_PerforMancd.capitalTurnover}}</span>
					  </template>
				    </el-table-column> -->
				    <el-table-column
				      prop="saleroom"
				      :label="$t('other.a1683')"
					  width="120"
					  :render-header="renderTipsHeaderss"
				      sortable
				      >
					  <template scope="scope">
					  	<span>￥{{mathnum((scope.row.Tol_PerforMancd.advCost).toFixed(2))}}</span>
					  </template>
				    </el-table-column>

					<el-table-column
				      prop="saleroom"
				      :label="$t('other.a1678')"
					  width="140"
					  :render-header="renderTipsHeaderjk"
				      sortable
				      >
					  <template scope="scope">
					  	<span>￥{{scope.row.Tol_PerforMancd.itemCost}}</span>
					  </template>
				    </el-table-column>
					<el-table-column
				      prop="saleroom"
				      :label="$t('other.a1681')"
					  width="120"
					  :render-header="renderTipsHeadertop"
				      sortable
				      >
					  <template scope="scope">
					  	<span>￥{{scope.row.Tol_PerforMancd.shipCost.toFixed(2)}}</span>
					  </template>
				    </el-table-column>

					<!-- <el-table-column
				      prop="saleroom"
				      label="断货次数"
					  width="120"
				      sortable
				      >
					  <template scope="scope">
					  	<span>{{scope.row.Tol_PerforMancd.supplyShortageNum}}</span>
					  </template>
				    </el-table-column> -->

					<el-table-column
				      prop="saleroom"
				      :label="$t('other.a1680')"
					  width="120"
				      sortable
				      >
					  <template scope="scope">
					  	<span>￥{{scope.row.Tol_PerforMancd.supplyShortageDay.toFixed(2)}}</span>
					  </template>
				    </el-table-column>

					 <el-table-column
				      prop="saleroom"
				      :label="$t('other.a1679')"
					  width="140"
				      sortable
				      >
					  <template scope="scope">
					  	<span>￥{{scope.row.Tol_PerforMancd.claim.toFixed(2)}}</span>
					  </template>
				    </el-table-column>
				
					
					
				

					<el-table-column
				      prop="saleroom"
				      :label="$t('other.a1684')"
					  width="160"
					  :render-header="renderTipsHeader"
				      sortable
				      >
					  <template scope="scope">
						  <!-- k.groupSalas ? p.Tol_PerforMancd.grossRate == p.Tol_PerforMancd.saleroom - p.Tol_PerforMancd.shipCost - p.Tol_PerforMancd.advCost - p.Tol_PerforMancd.capitalTurnover + p.Tol_PerforMancd.claim : 0 -->
					  	<span>￥{{ (scope.row.Tol_PerforMancd.saleroom - scope.row.Tol_PerforMancd.shipCost + scope.row.Tol_PerforMancd.advCost - scope.row.Tol_PerforMancd.capitalTurnover + scope.row.Tol_PerforMancd.claim).toFixed(2)}}</span>
					  </template>
				    </el-table-column>

					<el-table-column
				      prop="saleroom"
				      :label="$t('other.a1685')"
					  width="160"
				      sortable
				      >
					  <template scope="scope">
					  	<span v-if="scope.row.shopGroups!=null">{{(((scope.row.Tol_PerforMancd.saleroom - scope.row.Tol_PerforMancd.shipCost + scope.row.Tol_PerforMancd.advCost - scope.row.Tol_PerforMancd.capitalTurnover + scope.row.Tol_PerforMancd.claim)/scope.row.Tol_PerforMancd.saleroom)*100).toFixed(2)}}%</span>
						  <span v-if="scope.row.shopGroups==null">{{$t('other.a1682')}}</span>
					  </template>
				    </el-table-column>

					<el-table-column
				      prop="saleroom"
				      :label="$t('other.a1686')"
					  width="120"
				      sortable
				      >
					  <template scope="scope">
					  	<span v-if="scope.row.shopGroups!=null">{{((((scope.row.Tol_PerforMancd.saleroomRatio/scope.row.Tol_PerforMancd.saleroom)*0.3) + (((scope.row.Tol_PerforMancd.saleroom - scope.row.Tol_PerforMancd.shipCost + scope.row.Tol_PerforMancd.advCost - scope.row.Tol_PerforMancd.capitalTurnover + scope.row.Tol_PerforMancd.claim)/scope.row.Tol_PerforMancd.saleroom)*0.3) - ((scope.row.Tol_PerforMancd.advCost/scope.row.Tol_PerforMancd.saleroom)*0.3))*100).toFixed(2)  }}</span>
						<span v-if="scope.row.shopGroups==null">{{$t('other.a1682')}}</span>
					  </template>
				    </el-table-column>
					<el-table-column
				      prop="saleroom"
				      :label="$t('other.a1687')"
					  width="120"
				      sortable
				      >
					  <template scope="scope">
					  	<span>￥{{scope.row.Tol_PerforMancd.capitalTurnover.toFixed(2)}}</span>
					  </template>
				    </el-table-column>
				    <el-table-column
				      :label="$t('other.a33')"
					  width="180"
				      fixed="right"
				      >
				      <template scope="scope">
						  <el-button type="text" @click="addFeeOptions(scope.row,1)">{{$t('other.a1688')}}</el-button>
				      	<span>
				      		<el-dropdown  split-button type="primary" @click="handleClick(scope.row)">
				      		  {{$t('other.a1646')}}
				      		  <el-dropdown-menu slot="dropdown">
				      		    <!-- <el-dropdown-item ><span @click="addFeeOptions(scope.row,1)">{{$t('other.a1688')}}</span></el-dropdown-item> -->
				      		     <el-dropdown-item ><span @click="deleteGroup(scope.row)">{{$t('other.a1689')}}</span></el-dropdown-item>
				      		  </el-dropdown-menu>
				      		</el-dropdown>
				      	</span>
				      </template>
				    </el-table-column>
				  </el-table>
			</div>
		</div>
		
		
		
	</div>
</template>

<script>
import api from '../../api/moudles/group.js'
import utils from '../../utils/utils.js'
import TableDialog from './components/Dialog.vue'
import Loading from '../../components/loading_2.vue'
import { mapState } from 'vuex'
export default{
	data(){
		return {
			countryName:{
			                    'TH':this.$t("chat.Thailand"),
			                    'PH':this.$t("chat.thePhilippines"),
			                    'MY':this.$t("chat.Malaysia"),
			                    'ID':this.$t("chat.Indonesia"),
			                    'SG':this.$t("chat.Singapore"),
			                    'TW':this.$t("chat.Taiwan"),
								'VN':this.$t("chat.Vietnam"),
								'th':this.$t("chat.Thailand"),
			                    'ph':this.$t("chat.thePhilippines"),
			                    'my':this.$t("chat.Malaysia"),
			                    'id':this.$t("chat.Indonesia"),
			                    'sg':this.$t("chat.Singapore"),
			                    'tw':this.$t("chat.Taiwan"),
			                    'vn':this.$t("chat.Vietnam")
			                },
			showTable:false,
			showTable1:false,
			showTable3:false,
			groupInfo:[],
			groupIdTpp:null,
			FeeOptions:null,
			monthValue:'2021.08',
			yearValue:'',
			otherCost:[],
			groupInfoCopy:[],
			itemKey:0,
			cost:'',
			costName:'',
			quartersValue:'',
			options: [{
				  value: '1',
				  label: this.$t('other.a1661')
				}, {
				  value: '2',
				  label: this.$t('other.a1652')
				}, {
				  value: '3',
				  label: this.$t('other.a1662')
				}],
			value: '3',
			quaterOptions:[{
				  value: '1',
				  label: this.$t('other.a1690')
				}, {
				  value: '2',
				  label: this.$t('other.a1691')
				}, {
				  value: '3',
				  label: this.$t('other.a1692')
				},{
				  value: '4',
				  label: this.$t('other.a1693')
				}]
			
		}
	},
	watch:{
		monthValue(){
			if(this.value == 3) {
				this.getGropInfo()
			}
		},
		yearValue(){
			if(this.value == 1) {
				this.getGropInfo()
			}
		},
		quartersValue(){
			if(this.value == 2) {
				this.getGropInfo()
			}
		},
		
		value(){
			this.monthValue=''
			this.yearValue=''
			this.quartersValue=''
		}
	
		
	},
	components: {
		TableDialog,
		Loading
	},
	computed:{
		...mapState({
			userId: state=>state.login.userInfo.userId,
			userPos: state=>state.login.userInfo.userPos,
			vipLevel: state=>state.login.userInfo.vipLevel 
			
		}),
		
		
	},
	created(){
		setTimeout(() => {
			this.getGropInfo()
		},500)
	},
	methods:{
		showshopNameByshopIdOne(id){
		let obj= new Object();
		let shopList=utils.getAllshop().slice(1)
		shopList.forEach((p,index) => {
			obj[shopList[index].value]=p.label
			
		})
		return obj[id]
	},
	checkkShopname(id){
		let obj= new Object();
		let shopList=utils.getAllshop().slice(1)
		shopList.forEach((p,index) => {
			obj[shopList[index].value]=p.city
			
		})
		return obj[id]
	},
		renderTipsHeadertop (h,{column}) {
      return h(
        'div',[ 
             h('span', column.label),
             h('el-tooltip',{
　　　　      props:{
　　　　　　　　effect:'dark',
　　　　　　　　content:this.$t('other.a1694'),
　　　　　　　　placement:'top'
　　　　　　},　　　 
　　　　 },[
                 h('i', {
                     class:'el-icon-question',
                     style:'color:#409EFF;margin-left:5px;'
                 })
            ])
        ]
    );
 },
		renderTipsHeaderss (h,{column}) {
      return h(
        'div',[ 
             h('span', column.label),
             h('el-tooltip',{
　　　　      props:{
　　　　　　　　effect:'dark',
　　　　　　　　content:this.$t('other.a1695'),
　　　　　　　　placement:'top'
　　　　　　},　　　 
　　　　 },[
                 h('i', {
                     class:'el-icon-question',
                     style:'color:#409EFF;margin-left:5px;'
                 })
            ])
        ]
    );
 },
		renderTipsHeader (h,{column}) {
      return h(
        'div',[ 
             h('span', column.label),
             h('el-tooltip',{
　　　　      props:{
　　　　　　　　effect:'dark',
　　　　　　　　content:this.$t('other.a1696'),
　　　　　　　　placement:'top'
　　　　　　},　　　 
　　　　 },[
                 h('i', {
                     class:'el-icon-question',
                     style:'color:#409EFF;margin-left:5px;'
                 })
            ])
        ]
    );
 },
 renderTipsHeaderjk (h,{column}) {
      return h(
        'div',[ 
             h('span', column.label),
             h('el-tooltip',{
　　　　      props:{
　　　　　　　　effect:'dark',
　　　　　　　　content:this.$t('other.a1697'),
　　　　　　　　placement:'top'
　　　　　　},　　　 
　　　　 },[
                 h('i', {
                     class:'el-icon-question',
                     style:'color:#409EFF;margin-left:5px;'
                 })
            ])
        ]
    );
 },


		mathnum(num){
			return Math.abs(num)
		},
		nnfnv(item,num){
			if(num == 0){
				console.log(item)
				item.checked=true
				
			}else if(num == 1){//确认修改
				item.checked=false
				let params={
					groupId:item.groupId,
					userId:this.userId,
					name:item.name,
				}
				api
				.updateGroupInfo(params)
				.then(res => {
					if(res.code === 200 ) {
						this.$message.success(this.$t('other.a665'))
					}
				})
			}
			
			this.itemKey=Math.random()
			
		},
		
		deleteData(params){
			console.log(params)
			if(params.costType == 1) {//删除小组里的费用项
				this.groupInfo.forEach((p) => {
					p.otherCost.forEach((k,index) => {
						if(k.costName === params.costName && k.id == params.id){
							k.otherCost.splice(index,1)
						}
					})
				})
				console.log(this.groupInfo)
			}else if(params.costType == 0) {//删除商店里的费用项
				this.groupInfo.forEach(p => {
					p.shopGroups.forEach((k) => {
						k.otherCost.forEach((j,index) => {
							if(j.costName === params.costName && j.id == params.id){
								j.otherCost.splice(index,1)
							}
						})
						
					})
				})
			}
			this.getGropInfo()
		},
		
		updateData(params){
			
			if(params.costType == 1) {
				this.groupInfo.forEach(p => {
					if(p.groupId === params.groupId){
						p.otherCost.push(params)
					}
				})
				console.log(this.groupInfo)
			}else if(params.costType == 0) {
				this.groupInfo.forEach(p => {
					p.shopGroups.forEach(k => {
						if(k.shopId === params.shopId){
							k.otherCost.push(params)
						}
					})
				})
			}
			this.getGropInfo()
		},
		
		freshData(params){
			if(params.costType == 1) {
				this.groupInfo.forEach(p => {
					p.otherCost.forEach((k,index) => {
						if(k.id === params.id && k.costName == params.costName) {
							p.otherCost.splice(index,1,params)
						}
					})
				})
				
			}else if(params.costType == 0) {
				this.groupInfo.forEach(p => {
					p.shopGroups.forEach(k => {
						k.otherCost.forEach((j,index) => {
							if(j.id === params.id && j.costName == params.costName) {
								k.otherCost.splice(index,1,params)
							}
						})
					})
				})
			}
			
			this.getGropInfo()
		},
		
		deleShopGroup(item) {
			let params={
				 groupId: item.groupId,
				 id: item.id,
				 platform: "SHOPEE",
				 shopId: item.shopId
			}
			this.$confirm(this.$t('other.a1698'), this.$t("other.a142"), {
			  confirmButtonText: this.$t('other.a145'),
			  cancelButtonText: this.$t('other.a146'),
			  type: 'warning'
			}).then(() => {
				api
				.deleteShopGroup(params)
				.then(res => {
					if(res.code === 200) {
						this.$message.success(this.$t('other.a1699'))
						this.groupInfo.forEach((p) => {
							p.shopGroups.forEach((k,index) => {
								if(k.shopId == params.shopId){
									p.shopGroups.splice(index,1)
								}
							})
						})
					}
				})
			  
			})
			
		},
		
		addFeeOptions(item,num){
			this.FeeOptions.shopId=item.shopId
			this.FeeOptions.groupId=item.groupId
			this.FeeOptions.id=item.id
			this.FeeOptions.costType=num
			this.otherCost=item.otherCost
			this.showTable3=true
		},
		handleClick(item){
			console.log(item)
			this.showTable=true
			this.groupIdTpp=item.groupId
		},
		getTiem(time){
			return utils.renderTime(time)
		},
	
		// 小组绑定店铺
		bindShop(params){
			params.forEach(p => {
				api
				.bindShopGroup(p)
				.then(res => {
					if(res.code === 200) {
						this.$message.success(this.$t('other.a1700'))
						this.getGropInfo()
						this.showTable=false
					}else{
						this.$message.success(res.msg)
					}
				})
			})
			
			
		},
		//删除小组请求
		deleteGroup(item){
			let params={
				userId:this.userId,
				groupId:item.groupId,
				name:item.name
			}
			this.$confirm(this.$t('other.a608'), this.$t("other.a142"), {
			  confirmButtonText: this.$t('other.a145'),
			  cancelButtonText: this.$t('other.a146'),
			  type: 'warning'
			}).then(() => {
			  api
			  .deleteUserGroup(params)
			  .then(res => {
			  	if(res.code === 200) {
			  		this.$message.success(this.$t('other.a1701'))
			  		this.groupInfo.forEach((p,index) => {
						if(p.groupId == item.groupId) {
							this.groupInfo.splice(index,1)
						}
					})
			  	}else{
			  		this.$message.success(res.msg)
			  	}
			  })
			})
			
		},
		//创建小组请求
		createGroup(params){
			console.log(params);
			api
			.createShopGroup(params)
			.then(res => {
				if(res.code === 200) {
					this.$message.success(this.$t('other.a1702'))
					this.getGropInfo()
					console.log(res.data)
				}else{
					this.$message.success(res.msg)
				}
			})
		},
		
		//请求获取小组的数据
		getGropInfo(){
			let params={
					userId:this.userId,
					costType:0,
					months:1,
					quarters:null,
					timeType:parseInt(this.value),
					years:2021,
			}
			if(this.value == '1'){//按年份
				params.years=parseInt(utils.getCurrnetTime(this.yearValue).slice(0,4))
			}else if(this.value == '2'){//按季节
				params.years=parseInt(utils.getCurrnetTime(this.yearValue).slice(0,4))
				params.quarters=this.quartersValue
				
			}else if(this.value == '3'){//按月份
				params.years=parseInt(utils.getCurrnetTime(this.monthValue).split('-')[0])
				params.months=parseInt(utils.getCurrnetTime(this.monthValue).split('-')[1])
			}
			
			this.FeeOptions=params
			
			console.log(params)
			api
			.getUserGroup(params)
			.then(res => {
				if(res.code === 200) {
					console.log(res.data)
					this.groupInfo=res.data
					this.groupInfoCopy=res.data
					this.groupInfoCopy.forEach(p => {
						
						p.Tol_PerforMancd={
							saleroom:0,
							escrowAmount:0,
							grossRate:0,
							turnover:0,
							itemAmount:0,
							orderAmount:0,
							capitalTurnover:0,
							advCost:0,
							supplyShortageNum:0,
							supplyShortageDay:0,
							itemCost:0,
							claim:0,
							saleroomRatio:0,
							score:0,
							shipCost:0,

						}
						if(p.otherCost){
							p.otherCost.forEach(s =>{
								p.Tol_PerforMancd.capitalTurnover += s.cost
							})
						}
						
						if(p.shopGroups){

							p.shopGroups.forEach(k => {
								k.groupSalas ? p.Tol_PerforMancd.saleroom += k.groupSalas.saleroom :0
								k.groupSalas ? p.Tol_PerforMancd.escrowAmount += k.groupSalas.escrowAmount :0
								
								k.groupSalas ? p.Tol_PerforMancd.turnover += k.groupSalas.turnover :0
								k.groupSalas ? p.Tol_PerforMancd.itemAmount += k.groupSalas.itemAmount :0
								k.groupSalas ? p.Tol_PerforMancd.orderAmount += k.groupSalas.orderAmount :0
								
								k.groupSalas ? p.Tol_PerforMancd.advCost += k.groupSalas.advCost :0
								k.groupSalas ? p.Tol_PerforMancd.supplyShortageNum += k.groupSalas.supplyShortageNum :0
								k.groupSalas ? p.Tol_PerforMancd.supplyShortageDay += k.groupSalas.returnPrice :0
								k.groupSalas ? p.Tol_PerforMancd.itemCost += k.groupSalas.itemCost :0
								k.groupSalas ? p.Tol_PerforMancd.claim += k.groupSalas.claim :0
								k.groupSalas ? p.Tol_PerforMancd.saleroomRatio += k.groupSalas.comparative*k.groupSalas.saleroom :0
								k.groupSalas ? p.Tol_PerforMancd.score += k.groupSalas.score :0
								k.groupSalas ? p.Tol_PerforMancd.shipCost += k.groupSalas.shipCost :0
								// k.groupSalas ? p.Tol_PerforMancd.grossRate == p.Tol_PerforMancd.saleroom - p.Tol_PerforMancd.shipCost :0

							})
						}
				})
					console.log('shopGroups',this.groupInfoCopy)
				}
			})
		}
	}
	
}
</script>

<style>
	/* .gruop-wrapper{
		flex: 1;
		margin: 60px 0 0 235px;
		
		
	} */
	.group-box{
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		margin: 5px 10px 5px 5px;
		height: 48px;
		line-height: 48px;
		border-bottom: 1px solid #E0E0E0;
	}
	.gruop-wrapper .group-title{
		display: inline-block;
		margin-right: 20px;
	}
	.gruop-wrapper .group-title:nth-child(2){
		display: inline-block;
		width: 200px;
		margin-right: 20px;
	}
	.gruop-wrapper .el-table__expanded-cell{
		padding: 0 !important;
	}
	.gruop-wrapper .el-icon-edit{
		color: #409EFF;
		font-size: 16px;
		margin-left: 10px;
		cursor: pointer;
	}
</style>
